/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { styled } from "@mui/material/styles";

export default styled("a")(({ theme }) => {
  return {
    color: "#0000EE", // Standard blue for unvisited links
    textDecoration: "none",
    cursor: "pointer",

    "&:visited": {
      color: "#551A8B", // Standard purple for visited links
    },

    "&:hover": {
      textDecoration: "underline !important",
      color: "#0000EE",
      "&:visited": {
        color: "#551A8B", // Standard purple for visited links
      },
    },
  };
});
